import { locales } from './locales.js'

export const isIsoCountry = value =>
  typeof value === 'string' &&
  /^[A-Za-z]{2}$/.test(value) &&
  !['XX', 'T1', 'EU', 'AP'].includes(value.toUpperCase())

export function localePriceCountry(code) {
  const locale = locales.find(item => item.code === code) || locales[0]

  return locale.priceCountry || locale.country
}

export function priceCountry({ accountCountry, chosenCountry, locale }) {
  const country = [accountCountry, chosenCountry].find(isIsoCountry)

  return country ? country.toUpperCase() : localePriceCountry(locale)
}
